import { schema } from 'normalizr';

export const TAG_SCHEMA_KEY = 'tag';
export const tagSchema = new schema.Entity(TAG_SCHEMA_KEY);
export const tagListSchema = [tagSchema];
tagSchema.define({ children: tagListSchema });
